module.exports = __webpack_public_path__ + "img/portal_bg.02bd4167.png";